"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
class OrganisationSearch extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'organisationSearch';
        this._name = initParams.name;
        this._username = initParams.username;
        this._orgName = initParams.org_name;
        this._orgId = initParams.org_id;
        this._profilePicture = initParams.profile_picture;
        this._profilePictureThumbnail = initParams.profile_picture_thumbnail;
        this._colour = initParams.colour;
        this._imageUrl = initParams.image_url;
    }
    set name(value) {
        console.error('Do not set objects this way');
    }
    get name() {
        return this._name;
    }
    set username(value) {
        console.error('Do not set objects this way');
    }
    get username() {
        return this._username;
    }
    set orgName(value) {
        console.error('Do not set objects this way');
    }
    get orgName() {
        return this._orgName;
    }
    set orgId(value) {
        console.error('Do not set objects this way');
    }
    get orgId() {
        return this._orgId;
    }
    set profilePicture(value) {
        console.error('Do not set objects this way');
    }
    get profilePicture() {
        return this._profilePicture;
    }
    set profilePictureThumbnail(value) {
        console.error('Do not set objects this way');
    }
    get profilePictureThumbnail() {
        return this._profilePictureThumbnail;
    }
    set colour(value) {
        console.error('Do not set objects this way');
    }
    get colour() {
        return this._colour;
    }
    set imageUrl(value) {
        console.error('Do not set objects this way');
    }
    get imageUrl() {
        return this._imageUrl;
    }
}
exports.default = OrganisationSearch;
//# sourceMappingURL=organisationSearch.js.map